import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a front-load washing machine, 0.6 x 0.6 x 0.85 m: white
// body, round porthole door on +Z (dark glass disc in a steel ring) and a
// small control panel strip across the top front.
const BODY = "#f2f1ee";
const STEEL = "#aab2b8";
const DARK_GLASS = "#3a3f44";
const MATTE_BLACK = "#2e2e30";

export const washingMachine = defineModel({
  id: "washing-machine",
  batchId: "modern",
  name: "Washing machine",
  tags: ["modern", "interior", "appliance", "laundry", "washer"],
  summary: "A white front-load washer with a round glass door and a top control strip.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.52, 0.06, 0.44), color: MATTE_BLACK, position: [0, 0.03, -0.04] },
      // body (back flush at z = -0.3)
      { geometry: new THREE.BoxGeometry(0.6, 0.79, 0.56), color: BODY, position: [0, 0.455, -0.02] },
      // steel porthole ring
      { geometry: new THREE.CylinderGeometry(0.19, 0.19, 0.04, 20), color: STEEL, position: [0, 0.4, 0.27], rotation: [Math.PI / 2, 0, 0] },
      // dark glass door disc
      { geometry: new THREE.CylinderGeometry(0.14, 0.14, 0.05, 20), color: DARK_GLASS, position: [0, 0.4, 0.275], rotation: [Math.PI / 2, 0, 0] },
      // control panel strip across the top front
      { geometry: new THREE.BoxGeometry(0.56, 0.08, 0.02), color: STEEL, position: [0, 0.76, 0.27] },
      // control dial
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.02, 12), color: MATTE_BLACK, position: [-0.2, 0.76, 0.285], rotation: [Math.PI / 2, 0, 0] },
    ];
  },
  animations: [],
});
